import flowRight from 'lodash.flowright';
import React from 'react';
import { connect } from 'react-redux';

import Select, { components } from 'react-select';
import {
  SortableContainer,
  SortableElement,
  sortableHandle
} from 'react-sortable-hoc';

import { actions as reduxActions } from '../reducers';
import { reactSelectDefaultStyles } from '../../../consts/reactSelectDefaultStyles';
import { customSelectStyles } from '../styles/filters';

const arrayMove = (array, from, to) => {
  array = array.slice();
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  return array;
};

const SortableMultiValue = SortableElement(props => {
  const onMouseDown = e => {
    e.preventDefault();
    e.stopPropagation();
  };
  const innerProps = { ...props.innerProps, onMouseDown };
  return <components.MultiValue {...props} innerProps={innerProps} />;
});

const SortableMultiValueLabel = sortableHandle(props => (
  <components.MultiValueLabel {...props} />
));

const SortableSelect = SortableContainer(Select);

const GroupBy = ({ groupByOptions, updateFilters, filters }) => {
  const handleSelectChange = selected => {
    updateFilters({ key: 'groupedBy', value: selected });
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newValue = arrayMove(filters.groupedBy, oldIndex, newIndex);
    updateFilters({ key: 'groupedBy', value: newValue });
  };

  return (
    <SortableSelect
      useDragHandle
      axis="xy"
      onSortEnd={onSortEnd}
      distance={4}
      getHelperDimensions={({ node }) => node.getBoundingClientRect()}
      isMulti
      options={groupByOptions}
      value={filters.groupedBy}
      onChange={handleSelectChange}
      components={{
        MultiValue: SortableMultiValue,
        MultiValueLabel: SortableMultiValueLabel
      }}
      closeMenuOnSelect={false}
      customStyles={customSelectStyles}
      styles={reactSelectDefaultStyles}
    />
  );
};

const mapStatesToProps = ({ subscriptionsImproved }) => {
  return {
    filters: subscriptionsImproved.filters,
    groupByOptions: subscriptionsImproved.groupByOptions
  };
};

const mapDispatchToProps = {
  updateFilters: reduxActions.updateFilters
};

export default flowRight(connect(mapStatesToProps, mapDispatchToProps))(
  GroupBy
);
